import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Checkbox } from '@material-ui/core';

import { colors } from 'theme/color-palette';
import spotIcon from 'assets/svgs/spot-icon.svg';
import { Bogle_Medium } from 'constants/constant';

const Guide = (props) => {
	const classes = guideStyles();
	const doNotShowThis = (show) => localStorage.setItem('doNotShowOFTableGuide', show);

	return (
		<Box className={classes.container} style={{ width: props.width }}>
			<Box className={classes.iconBox}>
				<img className={classes.spotIconCls} src={spotIcon} alt="spot-icon"></img>
			</Box>
			<Box width={'100%'}>
				<h4 className={classes.heading}>Recommended data for Order Forecast</h4>
				<p className={classes.content}>
					To help you build a better report, we&apos;ve automatically added <b>DC/Store Number</b>{' '}
					and <b>DC/Store Type</b> as recommendations. Feel free to remove any that aren&apos;t
					relevant to your specific needs.
				</p>
				<Box className={classes.buttons}>
					<Button className={classes.primary} onClick={props.onClose}>
						Keep and continue
					</Button>
					<Button className={classes.secondary} onClick={props.onRemoveItems}>
						Remove
					</Button>
					<Box className={classes.checkBoxContainer}>
						<Checkbox
							color="primary"
							className={classes.checkBox}
							onChange={(e) => doNotShowThis(e.target.checked)}
						/>
						<p className={classes.checkBoxText}>Don&apos;t show this message again</p>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

const guideStyles = makeStyles(() => ({
	container: {
		padding: '16px',
		display: 'flex',
		backgroundColor: colors.FAUX_BRIGHT_GRAY
	},
	iconBox: {
		marginRight: '16px'
	},
	spotIconCls: { width: '40px', height: '40px' },
	heading: { margin: 0, fontSize: '18px', fontWeight: 500, fontFamily: Bogle_Medium },
	content: { margin: '8px 0 0', fontSize: '14px' },
	buttons: {
		gap: '8px',
		display: 'flex',
		marginTop: '8px',
		alignItems: 'center'
	},
	primary: {
		height: '32px',
		padding: '0 16px',
		borderRadius: '100px',
		backgroundColor: colors.PURPLE,
		'& span': {
			fontSize: '14px',
			color: colors.WHITE,
			fontFamily: Bogle_Medium
		},
		'&:hover': {
			backgroundColor: colors.DARK_PURPLE
		}
	},
	secondary: {
		height: '32px',
		padding: '0 16px',
		borderRadius: '100px',
		border: '1px solid #D5D6D8',
		backgroundColor: colors.WHITE,
		'& span': {
			fontSize: '14px',
			color: colors.PURPLE,
			fontFamily: Bogle_Medium
		}
	},
	checkBoxContainer: {
		display: 'flex',
		marginLeft: 'auto',
		alignItems: 'center'
	},
	checkBox: {
		height: '20px',
		width: '20px'
	},
	checkBoxText: {
		margin: 0,
		fontSize: '14px'
	}
}));

Guide.propTypes = {
	onClose: PropTypes.func,
	onRemoveItems: PropTypes.func
};

export default Guide;
